import JiraTeamPageContainer from './jira/TeamPageContainer';

/**
 * Registry mapping route slug (:connectorComponent) to team page container and
 * connector types that use it. Each container loads its own data and renders its view.
 */
const CONNECTOR_DASHBOARD_ROUTES = {
  jira: {
    component: JiraTeamPageContainer,
    connectorTypes: ['jira-cloud', 'jira-server'],
  },
};

/**
 * Get the dashboard entry (route slug + component) for a connector type.
 * Used to build tabs from teamConnectorConfigurations.
 * @param {string} connectorType - e.g. 'jira-cloud', 'jira-server'
 * @returns {{ routeSlug: string, component: React.Component } | null}
 */
export function getConnectorDashboardEntry(connectorType) {
  if (!connectorType) return null;
  const entry = Object.entries(CONNECTOR_DASHBOARD_ROUTES).find(([, v]) =>
    v.connectorTypes.includes(connectorType)
  );
  if (!entry) return null;
  const [routeSlug, { component }] = entry;
  return { routeSlug, component };
}

/**
 * Get the component to render for a route slug (:connectorComponent).
 * Decoupled from actual component name.
 * @param {string} connectorComponent - route param, e.g. 'jira'
 * @returns {React.Component | null}
 */
export function getComponentByRouteSlug(connectorComponent) {
  if (!connectorComponent) return null;
  const entry = CONNECTOR_DASHBOARD_ROUTES[connectorComponent];
  return entry ? entry.component : null;
}

/**
 * Find team connector configuration for a connector ID.
 * @param {Array} teamConnectorConfigurations
 * @param {string|number} connectorId
 * @returns {object|null}
 */
export function getTeamConnectorConfig(
  teamConnectorConfigurations,
  connectorId
) {
  if (!teamConnectorConfigurations?.length || connectorId == null) return null;
  return (
    teamConnectorConfigurations.find(
      (c) => String(c.connector_id) === String(connectorId)
    ) ?? null
  );
}
